import css from './index.module.scss';
import EfImg from 'elem/ui/ef-img';
import EfLink from 'elem/ui/ef-link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import gtm from '@/utils/gtm';
import { configs } from './configs';

export default function BlackFriday() {
    const { locale, pathname, query } = useRouter();
    const { includePages, includeSites, times } = configs;
    const now = query?._timer ? new Date(query?._timer).getTime() : new Date().getTime();
    const IS_ACTIVE = now >= new Date(times[locale]?.start).getTime() && now < new Date(times[locale]?.end).getTime();
    const IS_PRE = now < new Date(times[locale]?.start).getTime();
    const showFlag = (IS_ACTIVE || IS_PRE) && includePages.includes(pathname) && includeSites.includes(locale);
    const [top, setTop] = useState(0);

    const localImgs = {
        us: {
            a: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1730343708845/pc_11.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1730341807820/M_pre.jpg',
            },
            b: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1730343708965/pc_22.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1730341807058/m_lau.jpg',
                link: `https://${locale}.ecoflow.com/pages/black-friday`,
            },
        },
    };

    const img = (localImgs[locale] || localImgs['us'])[IS_ACTIVE ? 'b' : 'a'];

    useEffect(() => {
        const elems = ['.product-menu', '.ecoflow-frame-header'];
        let h = 0;
        const timer = setTimeout(() => {
            elems?.map((cls) => {
                const elem = document.querySelector(cls);
                if (elem) {
                    const computedStyle = window.getComputedStyle(elem);
                    const positionValue = computedStyle.getPropertyValue('position');
                    const topValue = computedStyle.getPropertyValue('top');
                    if (positionValue === 'sticky') {
                        h += elem.offsetHeight + parseInt(topValue);
                    }
                }
            });
            setTop(h);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {showFlag && (
                <div className={`${css['black-friday']} black-friday activity-bar`} style={{ top: top + 'px' }}>
                    {IS_ACTIVE && (
                        <EfLink
                            href={img?.link}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'select_banner',
                                banner_name: 'Black Friday Sale: Up to $4000 Off',
                                position: 'activityBanner_1',
                                button_name: 'none',
                            }}
                        >
                            <EfImg pc={img.pc} h5={img.h5} />
                        </EfLink>
                    )}
                    {IS_PRE && <EfImg pc={img.pc} h5={img.h5} />}
                </div>
            )}
        </>
    );
}
